module.exports = __webpack_public_path__ + "static/img/02560_8.98aba02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_8.jpg
// module id = DCrv
// module chunks = 1